import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { usersData$ } from "../reduxStore/selectors/userSelectors";
import { getAccessToken } from "../api/config";
import { hasRole } from "../utils/Enum/RoleEnum";
import { ADMIN_ROUTE_ACCESSIBLE_ROLES } from "../utils/roleAccess";

export default function AdminRoute({ children }) {
    const token = getAccessToken();
    const userData = useSelector(usersData$);
    const hasAccess = hasRole(userData, ADMIN_ROUTE_ACCESSIBLE_ROLES);

    if (!token || !userData) {
        return <Navigate to="/sign-in" replace />;
    }

    if (!hasAccess) {
        return <Navigate to="/user-dashboard" replace />;
    }

    return children;
}